// 深色页脚：logo_bottom + 备案 + 公司 + 版权
export default function Footer() {
  return (
    <footer className="bg-gray-900 border-t border-gray-800 py-8 text-gray-400">
      <div className="container mx-auto px-4 flex flex-col items-center gap-4">
        <img alt="Footer Logo" src="/logo_bottom.png" className="h-8 object-contain opacity-60 grayscale brightness-200" />
        <div className="text-center text-sm space-y-2">
          <p>
            <a href="http://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">苏ICP备2022045655号-1</a>
          </p>
          <p className="font-medium">衣图云创（南京）设计有限公司</p>
          <p>CopyRight © 2018-2026 All Rights Reserved</p>
        </div>
      </div>
    </footer>
  );
}
